import Vue from 'vue';
import {compactBreakpoints} from '@/constants/view-breakpoints';

const globalModule = {
  namespaced: true,
  state: {
    useToastInterceptor: true,
    isCompactView: false,
    viewBreakpoint: null,
    headerHeight: 0,
  },

  getters: {
    viewBreakpoint(state) {
      return state.viewBreakpoint;
    },
  },

  mutations: {
    setUseToastInterceptor(state, payload) {
      Vue.set(state, 'useToastInterceptor', payload);
    },

    setIsCompactView(state, payload) {
      state.isCompactView = payload;
    },

    setViewBreakpoint(state, payload) {
      state.viewBreakpoint = payload;
    },

    setHeaderHeight(state, payload) {
      state.headerHeight = payload;
    },
  },

  actions: {
    updateViewportState({commit}, payload) {
      commit('setViewBreakpoint', payload);
      commit('setIsCompactView', Object.keys(compactBreakpoints).includes(payload));
    },
  },
};

export default globalModule;
